/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState } from "react";
import { CircularProgress } from "@mui/material";
import { useCustomerAuth } from "cms/auth-customer/use-customer-auth";

const PleaseLogin = () => {

    const [registerProcessing, setRegisterProcessing] = useState(false);
    const { processing, login } = useCustomerAuth();

    const register = async () => {
        setRegisterProcessing;
        console.log(`Starting Register`);
        await login();
    };

    return (
        <>
            <p>To access city services, you must be logged in.</p>
            <p>&nbsp;</p>
            <h2>
                Login to your account.
            </h2>
            <div className='simplicity-loginbutton'>
                <a
                    className={`btn icon`}
                    onClick={login}
                >
                    <div style={{ width: "50px", height: "25px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        {!processing && <>Login</>}
                        {processing &&
                            <CircularProgress
                                style={{ height: "25px", width: "25px", color: "white" }}
                                color="primary"
                            />
                        }
                    </div>
                </a>
            </div>
            <h2>
                Don&apos;t have an account?
            </h2>
            <p>Signing up is quick and gives you access to a variety of city services.</p>
            <p>&nbsp;</p>

            <p>With a Services account, you can:</p>
            <ul style={{ listStyleType: "circle", listStyle: "inside" }}>
                <li>Manage and apply for permits</li>
                <li>Make payments to the city</li>
                <li>And more</li>
            </ul>
            <p>&nbsp;</p>

            <div className='simplicity-linkbutton outline'>
                <a
                    className={`btn icon`}
                    onClick={register}
                >
                    <div style={{ width: "50px", height: "25px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        {!registerProcessing && <>Register</>}
                        {registerProcessing &&
                            <CircularProgress
                                style={{ height: "25px", width: "25px", color: "white" }}
                                color="primary"
                            />
                        }
                    </div>
                </a>
            </div>
            <p>&nbsp;</p>
        </>
    );
};

PleaseLogin.displayName = "PleaseLogin";
export { PleaseLogin };
